import type { ConfigProviderProps } from 'antd/es/config-provider';

const rangePickerConfig: ConfigProviderProps['rangePicker'] = { separator: '~' };

export default rangePickerConfig;
